/**
 * D-317 §3 — attached files as uniform tiles in a row (the ticket window and the
 * portal request): an image is a same-size square that opens large on click, a
 * video keeps its "play" tile and player, a recording a small player. The class
 * only sizes the existing viewers (AttachmentMedia / the ticket's attachment bubble).
 */
export const ATTACHMENT_TILES_CLASS = [
  'grid grid-cols-2 gap-2.5 sm:grid-cols-4 list-none',
  '[&_img]:h-24 [&_img]:w-full [&_img]:max-w-full [&_img]:object-cover',
  '[&_.w-40]:w-full [&_.w-72]:w-full [&_audio]:max-w-full [&_video]:max-w-full',
].join(' ');
